<template>
  <div>
    <slot></slot>
    <h5-cropper ref="cropper" v-model="isShowBg" class="absolute" :style="this.h5Styles" :option="option"
                @imgorigoinf="loadImg" @getFile="getFile"></h5-cropper>
  </div>
</template>
<script>
import { Toast } from 'vant'
import MyH5Cropper from './my-cropper-components'

export default {
  name: 'my-cropper',
  components: {
    'h5-cropper': MyH5Cropper
  },
  props: ['option', 'styles'],
  data () {
    return {
      isOK: false,
      isShowBg: false
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {
    h5Styles() {
      return {
        overflow: 'hidden',
        marginTop: '-0.6rem',
        ...this.styles
      }
    }
  },
  watch: {},
  methods: {
    loadImg (file) {
      if (file.size < 100 * 1024 || file.size > 10 * 1024 * 1024) {
        Toast('照片大小必须在100KB到10M之间')
        this.isOK = false
      } else {
        this.isShowBg = true
        this.isOK = true
      }
    },
    getFile (file) {
      if (this.isOK) {
        this.$emit('change', { file: file })
      } else {
        Toast('照片大小必须在100KB到10M之间')
      }
    }
  }
}
</script>
